import axios from "axios";
import { useMemo, useState } from "react";
import Dropdown from "@shared/v2/Dropdown";
import useQuickSearch from "../../Dashboard/services/useQuickSearch";

interface Person {
  objectId: string;
  label: string;
  loginUserId?: string;
  status: string;
  type: string;
}

interface ImportPersonSearchProps {
  modalType: string;
  onChange: (person: Person) => void;
}

const ImportPersonSearch = ({ modalType, onChange }: ImportPersonSearchProps) => {
  const [person, setPerson] = useState<Person>(null);
  const [search, setSearch] = useState("");
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { data, error, loading } = useQuickSearch({ search, model: "Person" });
  const options = useMemo<Person[]>(
    () => (modalType === "lender" ? (data as Person[]) : (data as Person[]).filter((p) => !p.loginUserId)),
    [data],
  );

  return (
    <>
      <Dropdown
        // @ts-expect-error TS2322
        label="Import Person Details"
        placeholder="Search for an existing team member to auto-populate the info below"
        helperText="Already added a lender to your team? Import their details here! Please note that you will still need to manually update details even after importing."
        getOptionLabel={(option: Person) => `${option.label} (${option.status} ${option.type})`}
        onInputChange={setSearch}
        shouldFilterOptions={false}
        onChange={(option: Person) => {
          setPerson(option);
          if (option) {
            axios
              .get(`/api/v4/contact_people/${option.objectId}`)
              .then((res) => {
                onChange(res.data as Person);
              })
              .catch(console.log);
          } else {
            onChange(null);
          }
        }}
        value={person}
        options={options}
        isSearchable
        error={error as string}
        isLoading={loading}
      />
      <div className="tw-bg-gray-10 tw-h-[1px] tw-w-full" />
    </>
  );
};

export default ImportPersonSearch;
